export const PROP_NAME = '_nextI18Next';
export const GLOBAL_NAME = '__NEXT_I18NEXT_EXT';
export const COMPONENT_DISPLAY_NAME = 'AppWithTranslationExt';
